/* eslint-disable no-underscore-dangle */
import { fabric, LayerManager } from '@aibee/vincent';
import svg from '@/assets/icons/svg/elevator2.svg';

// 直梯
fabric.Elevator = fabric.util.createClass(fabric.Group, {

  type: 'Elevator',

  initialize(options) {
    this.initParams(options);
    const { shapeParams = {} } = this.config;
    shapeParams.hoverCursor = 'pointer';

    fabric.loadSVGFromString(svg.content.replace(/symbol/g, 'svg'), (objects, opt) => {
      const obj = fabric.util.groupSVGElements(objects, opt);
      obj.scale(0.5);
      this.callSuper('initialize', [obj], shapeParams);
      LayerManager.getCurrentLayer().canvas.renderAll();
    });

    this.initEvents();
  },

  toObject() {
    return fabric.util.object.extend(this.callSuper('toObject'), {
      property: this.property,
    });
  },

  _render(ctx) {
    this.callSuper('_render', ctx);
  },
});
